import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 20.5725V10.5725M12 20.5725V4.57251M6 20.5725V14.5725"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardIcon;
